"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, useSpring } from "motion/react";
import { useEffect } from "react";
import { chartCssVars } from "../chart-context";

// Faster spring to stay in sync with indicator
const crosshairSpringConfig = {
  stiffness: 300,
  damping: 30
};
export interface TooltipDotProps {
  x: number;
  y: number;
  visible: boolean;
  color: string;
  size?: number;
  strokeColor?: string;
  strokeWidth?: number;
}
export function TooltipDot(t0) {
  const $ = _c(13);
  const {
    x,
    y,
    visible,
    color,
    size: t1,
    strokeColor: t2,
    strokeWidth: t3
  } = t0;
  const size = t1 === undefined ? 5 : t1;
  const strokeColor = t2 === undefined ? chartCssVars.background : t2;
  const strokeWidth = t3 === undefined ? 2 : t3;
  const animatedX = useSpring(x, crosshairSpringConfig);
  const animatedY = useSpring(y, crosshairSpringConfig);
  let t4;
  let t5;
  if ($[0] !== animatedX || $[1] !== animatedY || $[2] !== x || $[3] !== y) {
    t4 = () => {
      animatedX.set(x);
      animatedY.set(y);
    };
    t5 = [x, y, animatedX, animatedY];
    $[0] = animatedX;
    $[1] = animatedY;
    $[2] = x;
    $[3] = y;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  if (!visible) {
    return null;
  }
  let t6;
  if ($[6] !== animatedX || $[7] !== animatedY || $[8] !== color || $[9] !== size || $[10] !== strokeColor || $[11] !== strokeWidth) {
    t6 = <motion.circle cx={animatedX} cy={animatedY} fill={color} r={size} stroke={strokeColor} strokeWidth={strokeWidth} />;
    $[6] = animatedX;
    $[7] = animatedY;
    $[8] = color;
    $[9] = size;
    $[10] = strokeColor;
    $[11] = strokeWidth;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
TooltipDot.displayName = "TooltipDot";
export default TooltipDot;